import DOMPurify from 'dompurify';
import {
  Grid, Link, Typography,
} from '@mui/material';
import { v4 as uuid } from 'uuid';
import { Fragment, useEffect } from 'react';
import BlockSettings from '../../../../models/BlockSettings';
import LinkData from '../../../../models/LinkData';
import Utils from '../../../../utils/Utils';
import CloseButton from '../../../Buttons/Close';

interface FooterMenuProps {
  menus: LinkData[];
  footerSettings: BlockSettings;
  isEditing: boolean;
  direction?: 'row' | 'column';
  handleMenuDelete: () => void;
  handleOpen: () => void;
}

const sanitizer = DOMPurify.sanitize;

function FooterMenu({
  menus, footerSettings, isEditing, direction = 'row', handleMenuDelete, handleOpen,
}: FooterMenuProps) {
  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();

        let href = anchor.getAttribute('href');
        href = href.replace('#', '');

        if (href && href !== '#' && href !== '#!') {
          const headerEl = document.querySelector('.blockFooterType');
          const headerOffset = headerEl ? headerEl.clientHeight : 0;

          const targetEl = document.getElementById(href);
          targetEl.style.scrollMarginTop = `${headerOffset}px`;

          if (targetEl) {
            targetEl.scrollIntoView({
              behavior: 'smooth',
            });
          }
        }
      });
    });
  }, [menus]);

  return (
    <Grid item xs={12} sx={{ ...Utils.hoverBorder(isEditing), padding: '16px' }}>
      {isEditing && <CloseButton updateHandler={handleMenuDelete} />}
      <Grid
        container
        spacing={2}
        direction={direction}
        alignItems={footerSettings?.align}
        justifyContent={footerSettings?.justify}
        wrap="wrap"
        onClick={handleOpen}
      >

        {menus.map((menu) => (
          <Fragment key={uuid()}>
            <Grid item xs="auto">
              {!isEditing && (
                <>
                  <Link
                    href={menu.linkData.url}
                    target={menu.linkData.openType}
                    rel="noreferrer"
                    underline="hover"
                    color="grey"
                    variant="subtitle1"
                    m="auto"
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: sanitizer(menu.title) }}
                    />
                  </Link>
                </>
              )}

              {isEditing && (
                <Typography color="grey" variant="subtitle1" m="auto">
                  <div
                    dangerouslySetInnerHTML={{ __html: sanitizer(menu.title) }}
                  />
                </Typography>
              )}
            </Grid>

            {menus?.indexOf(menu) !== menus.length - 1 && (
              <Grid item xs="auto" style={{ fontSize: '20px', color: footerSettings?.separatorColor }}>
                {footerSettings?.separator}
              </Grid>
            )}
          </Fragment>
        ))}
      </Grid>
    </Grid>
  );
}

export default FooterMenu;
